import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stop"}/>
}
